import React from 'react';
import NotFound from './NotFound';

export default  () => <NotFound message="Looks like you've followed a broken link or entered a resort into the address bar that doesn't exist on this site." />


// WEBPACK FOOTER //
// ./src/app/ResortNotFound.js